import * as React from 'react';
import { PropsWithChildren, useEffect, useMemo } from 'react';
import window from 'window-or-global';
import { Dimension, getWindowDimension, isWithinBreakpoint } from './responsive.util';

type ResponsiveProps = PropsWithChildren<{
  breakpoints: Array<'mobile' | 'tablet' | 'desktop' | 'lg-desktop' | 'xl-desktop'>;
}>;

/**
 * Responsive component
 *
 * Adapted from: https://github.com/applike/typed-responsive-react
 * */
export const Responsive: React.FunctionComponent<ResponsiveProps> = ({ children, breakpoints }) => {
  const [{ width, height }, setDimensions] = React.useState<Dimension>(() => getWindowDimension());

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setDimensions(getWindowDimension());
    };

    window.addEventListener('resize', handleResize, false);

    return () => {
      window.removeEventListener('resize', handleResize, false);
    };
  }, []);

  const shouldRender = useMemo(() => {
    if (width === 0 && height === 0) return false;
    for (const breakpoint of breakpoints) {
      if (isWithinBreakpoint(breakpoint)) return true;
    }
    return false;
  }, [breakpoints, width, height]);

  return <>{shouldRender ? children : null}</>;
};
